import { parse, isValid, differenceInDays } from 'date-fns';

const DATE_PATTERNS = [
  {pattern: 'yyyy-MM-dd'},
  {pattern: 'MM/dd/yyyy'},
  {pattern: 'MM/dd/yy'},
  {pattern: 'M/d/yyyy'},
  {pattern: 'M/d/yy'},
  {pattern: 'MMMMMM dd, yyyy'},
  {pattern: 'MMMMMM dd yyyy'},
  {pattern: 'MMMMMM do, yyyy'},
  {pattern: 'MMMMMM do yyyy'},
  {pattern: 'EEEE, MMMM dd, yyyy'},
  {pattern: 'EEEE MMMM dd, yyyy'},
  {pattern: 'EEEE MMMM dd yyyy'},
  {pattern: 'MMMM dd', fillInYear: true},
  {pattern: 'MM/dd', fillInYear: true},
  {pattern: 'dd/MM', fillInYear: true},
];

function adjustYear(value) {
  // find closest recent year
  let years = [new Date().getFullYear(), new Date().getFullYear() - 1, new Date().getFullYear() + 1];
  let dates = years.map((year) => {
    let d = new Date(value)
    d.setFullYear(year);
    return {
      date: d,
      diff: Math.abs(differenceInDays(new Date(), d))
    }
  });
  let validDates = dates.sort((date1, date2) => {
    return date1.diff < date2.diff ? -1 : 1;
  })
  return validDates[0].date
};

export default function inferDate(date, hash) {
  if (!date) return '';

  let startTime = hash.start;
  let endTime = hash.end;
  let timeZone = hash.timeZone;

  var validDates = [];
  for (var data of DATE_PATTERNS) {
    try {
      var parsedDate = parse(date.toString(), data.pattern, 0, {
        timeZone: timeZone,
      });

      if (isValid(parsedDate)) {
        if (parsedDate.getYear() < 100) {
          parsedDate.setFullYear(parsedDate.getFullYear() + 2000);
        }

        if (data.fillInYear) {
          validDates.push({pattern: data.pattern, date: adjustYear(parsedDate), input: date})
        } else {
          validDates.push({pattern: data.pattern, date: parsedDate, input: date})
        }
      }
    }
    catch(e) {
      // nothing
    }
  }

  if (validDates.length > 0) {
    // let dates = validDates.filter(data => {
    //   if (startTime && endTime) {
    //     if (data.date >= startTime && data.date <= endTime) {
    //       return data;
    //     }
    //   } else {
    //     return data.date;
    //   }
    // })

    if (validDates.length > 0) {
      return validDates[0].date;
    }
  }
}